import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

export const task: Task = {
  id: "4f229c16-bac4-48df-8d53-95e249dc5f58",
  solutionType: "text-or-number",
  type: "fillTheGap",
  options: {
    type: "number",
    shuffle: false,
    prefixText: "Dc(45°) =",
    suffixText: "m",
  },
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "text-or-number",
  data: 1.96,
};
